/**
 * AUTO-GENERATED AT BUILD TIME - DO NOT EDIT.
 *
 * Source: https://cc-fe-bifrost.prod-east.frontend.public.atl-paas.net/bifrost-static/assets/master/preload-query-batch-config.json
 */
// prettier-ignore
export const Q: readonly string[] = [
	"ApprovalsContextApprovalsDataQuery",
	"ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
	"ArchivedPageBannerV2ArchivedPageBannerQuery",
	"BlogTreeRootComponentQuery",
	"CollabDraftQuery",
	"CollabDraftWithRelevanceQuery",
	"ContentBlogUnifiedQuery",
	"ContentHeaderPresenceContentSettingsQuery",
	"ContentHeaderUnifiedQuery",
	"ContentPrerequisitesQuery",
	"ContentRedirectQuery",
	"ContentTypesHeaderQuery",
	"ContentUnifiedQuery",
	"ContentUnifiedWithSpaceKeyQuery",
	"CookieConsentPreferences",
	"CoverPictureQuery",
	"CustomHeaderFooterQuery",
	"DatabaseContainerQuery",
	"EditContentButtonQuery",
	"EditorContentStateQuery",
	"EditorPreferencesQuery",
	"EmojiTitleQuery",
	"EndOfPageRecommendationQuery",
	"FollowingFeedWithSortByStorageSnippetsQuery",
	"FooterCreateButtonsQuery",
	"ForgeExtensionList",
	"GlobalNavigationComponentQuery",
	"GrantAccessDialogLoaderQuery",
	"HomeRecentWorkQuery",
	"InlineCommentsFocusedInlineCommentQuery",
	"InvitedAppShortcutsRecommendationsQuery",
	"IsSuperAdminQuery",
	"LegacyMacroRendererQueryBodyQuery",
	"LivePagesByLineLastUpdatedQuery",
	"LocalStorageQuery",
	"NativeCollabQuery",
	"NotFoundContainerQuery",
	"NotificationsButtonQuery",
	"ObjectCommentContainerPreloadObjectCommentsQuery",
	"PageRestrictionsContextQuery",
	"PageTreeQuery",
	"PageTreeQueryWithSpaceKeyQuery",
	"PermissionCheckAddCommentQuery",
	"PersistentInviteEligibleQuery",
	"PersonalizedTemplatesV2AllTemplatesQuery",
	"PopularFeedWithTimeGranularityStorageSnippetsV2Query",
	"ReactionsContentQuery",
	"RendererContentStateQuery",
	"RestrictedPageWithCanViewQuery",
	"ScreenQuery",
	"SiteInformationQuery",
	"SmartCreateFeedbackBannerQuery",
	"SmartCreatePageEditorDataWrapperComponentQuery",
	"SpaceNavigationQuery",
	"SpaceOverviewIdQuery",
	"SpaceOverviewQuery",
	"SpaceQuery",
	"SpaceRestrictionCheckQuery",
	"ThemeQuery",
	"TopNavigationQuery",
	"UserSettingsQuery",
	"ViewSpaceExternalCollaboratorsDialogQuery",
	"WebItemLocationQuery_page.metadata.banner",
	"WebItemLocationQuery_system.content.action_system.content.button_system.editor.precursor.buttons",
	"WebItemLocationQuery_system.content.action_system.editor.precursor.buttons",
	"WebItemLocationQuery_system.content.byline",
	"WebItemLocationQuery_system.header_left",
	"WebItemLocationQuery_system.user",
	"WebPanelLocationQuery_atl.footer",
	"WebPanelLocationQuery_atl.general",
	"WebPanelLocationQuery_atl.general_atl.footer",
	"WebPanelLocationQuery_atl.page.content.footer.actions",
	"WebStorageCategories",
	"WelcomeMessagesQuery",
	"WhiteboardUnifiedQuery",
	"contentAppearanceQuery",
	"contentSmartLinksORS",
	"fetchMentionsProviderDataQuery",
	"graphqlHelpersDSPIsActionEnabledForContentQuery",
	"graphqlHelpersFetchMediaTokenQuery",
	"graphqlHelpersFetchMediaTokenWithMediaItemsQuery",
	"loomUserPermissionQuery",
	"multiMacroQueryWithAppKeyQuery",
	"onboardingStateGetOnboardingStateQuery",
	"onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_9",
	"onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered",
	"onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_3",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_5",
	"onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6",
	"onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2",
	"onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12",
	"onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt",
	"onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18",
	"onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_65",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6",
	"onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_160",
	"onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_161",
	"pageButtons",
	"preloadAutohighlightsQuery",
	"preloadContentSmartLinksQuery",
	"preloadCreateSpaceQuery",
	"preloadEditButtonWithSpaceKeyQuery",
	"preloadEditorNodeDataProvidersDataQuery",
	"preloadForgeApps_FetchPreFilteredForgeAppsQuery",
	"preloadLegacyBridgeQuery",
	"preloadOperationsQuery",
	"preloadPageStatusQueryDataQuery",
	"preloadPendingRequestExistsQuery",
	"preloadPersonalSpaceDetailsQuery",
	"preloadShareAndRestrictButtonQuerySpaceOverviewQuery",
	"preloadSpaceBlogCountQuery",
	"preloadTemplatesCollectionEligibleQuery",
	"requireSuperBatchFrontendResourceRenderQuery",
	"searchResults",
	"shortcutsSmartLinksQuery",
	"sidenavSmartLinksORS",
	"useAnalyticsByLineQuery",
	"useAudioContentQuery",
	"useBlogPostsQueryQuery",
	"useConfluenceStandardToPremiumExperimentQuery",
	"useConnectorOnboardingStateQuery",
	"useConnectorOnboardingTeamTypeQuery",
	"useConnectorStatesQuery",
	"useContentByLabelDataQuery",
	"useContentClassificationContentDataClassificationQuery",
	"useEditorContentModeValueQuery",
	"useEmojiEverSetPropertyQuery",
	"useFabricEligibilityMigrationQuery",
	"useFeatureDiscoveryFeatureDiscoveryQuery",
	"useFeedTypeSelectorRefreshQuery",
	"useGetCurrentStorageUsageQuery",
	"useGetTeamAndSubanchorGetPersonalSpaceKeyQuery",
	"useGetTeamAndSubanchorGetSubanchorsAGGQuery",
	"useHomeWidgetStateQuery",
	"useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery",
	"useIsLoomEntryPointsEnabledQuery",
	"useIsUserViewingSpaceAsAnonQuery",
	"useLicensedProductsQueryForGlobalAppShortcutsQuery",
	"useLoomTenantProvisionStatusQuery",
	"usePageTreeSearchQueryQuery",
	"usePopularFeedWithTimeGranularityStorageQuery",
	"usePreloadCommentButtonQuery",
	"useReadTimeQuery",
	"useRegisterAdminAnnouncementBannerQuery",
	"useShareAndRestrictButtonDataQuery",
	"useShortcutsSpaceNavigationQuery",
	"useSpaceBaseQueryBaseQuery",
	"useSpaceDetailQuery",
	"useSpaceEnabledContentTypesQuery",
	"useSpaceViewsDataSpaceRootQuery",
	"useSpaceViewsOptionsPersistenceQuery",
	"useSpacesDataAnonymousSpacesQuery",
	"useSpacesDataMyVisitedSpacesQuery",
	"useSpacesDataStarredSpacesQuery",
	"useTitleContentPropertiesForEditorQuery",
	"useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
	"useTitleContentPropertiesForPublishedPageQuery",
	"useUserByLicensedProductsQuery"
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	"prod-apne": "cfaf3d67fed7ff7fb6ec7efdefff7b0abffbdee703",
	"prod-apne2": "8baf3d67fed7ff7fb6ec7efdefff6f3aff7bdee703",
	"prod-apse": "cfef3d7ffed7ff7fb6ec7effefff7b0efffbdeef03",
	"prod-apse2": "cfef3d6ffed7ffffbfee7efdefff7f3afffbdeff03",
	"prod-apsouth": "cbbf3d67fed7ff7fb6ef7efdefff6f3bfb7bdee703",
	"prod-cacentral": "cfef3d77fedfff7fbeee7efdefff6f7aff7fdef703",
	"prod-east": "cfef3fcffedfffffbfee7effefff7f7effffdeff03",
	"prod-eucentral": "c7ef3fcefed4ff7fbfec7effefff7f3adfebdeff03",
	"prod-eucentral2": "c7ef3d43fed7fe7f86ac7afdefff6b08ff7bdee603",
	"prod-euwest": "cfef3feffed7ffffffee7effefff7f3affffdeff03",
	"prod-euwest2": "cfef3d6ffed7ff7fb6ee7efdeffe6f3adf7bdeef03",
	"prod-west2": "cfef3defffdfffffb7ee7effefff7f3affffdee703",
	"stg-east": "ca493905aa890c6eb0e2c5b1da7049632b7fba6603"
};

export const generatedAt: string | null = "2026-08-18T03:08:04.563Z";

export const sourceUrl: string | null = "https://cc-fe-bifrost.prod-east.frontend.public.atl-paas.net/bifrost-static/assets/master/preload-query-batch-config.json";
